import fetch from '../utils/fetch'

import { BASE_URL } from './constants'


export const login = (account) => {
  return fetch(`${BASE_URL}/login/`, {
    method: 'POST',
    body: JSON.stringify(account)
  }, true)
}

export const changePassword = (account) => {
  return fetch(`${BASE_URL}/system-user-change-password/`, {
    method: 'POST',
    body: JSON.stringify(account)
  }, true)
}



// WEBPACK FOOTER //
// ./src/services/loginServices.js